import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Home2 from "./Home2";

import Button from "react-bootstrap/Button";


function Home() {

 

  const handleClick = () => {
    window.open("https://www.favrhood.com/", "_blank", "noopener,noreferrer");
  };

  return (
    <section>
      <Container fluid className="home-section home-page" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="home-hero" style={{ justifyContent: "center" }}>
            <Col md={10} lg={8} className="home-hero-col">
              <div className="home-hero-media">
                <div className="home-hero-logo-circle">
                  <img src={homeLogo} alt="Choicest Fruit" className="img-fluid home-hero-logo" />
                </div>
              </div>

              <div className="policy-card home-hero-card">
                <div className="home-hero-card-body">
                  <h1 className="home-hero-title">
                    Choicest Fruit<span className="small-r-symbol">®</span>
                  </h1>

                  <p className="home-hero-lead">
                    Knowledge and Technology <strong className="main-name">Serving the Welfare of Humanity</strong>
                  </p>

                  <div className="home-cta">
                    <Button onClick={handleClick} size="lg" className="custom-yellow-btn home-cta-btn">
                      Join Favrhood - Our Community Platform for Local Innovation
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
